import React from "react";
import PropTypes from "prop-types";
import SidebarIconSvg from "./SidebarIconSvg";

const SidebarIconPlus = ({ className, size }) => (
  <SidebarIconSvg className={className} size={size}>
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </SidebarIconSvg>
);

SidebarIconPlus.propTypes = {
  className: PropTypes.string,
  size: PropTypes.number
};

export default SidebarIconPlus;
